export const iconFontAwesomeNatureVolcano = (
	<i className="fa-solid fa-volcano"></i>
);
